<script>
import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

Chart.register(BarController, BarElement, CategoryScale, LinearScale);

export default {
  props: {
    // [{ value: Number, color: String, label: String }]
    segments: { type: Array, required: true },
    // Value-axis max; falls back to the sum of the segments when not positive
    max: { type: Number, default: 0 },
    trackColor: { type: String, default: "#f0f0f0" },
    title: { type: String, default: "" },
    titleColor: { type: String, default: "#34c38f" },
    barThickness: { type: Number, default: 15 },
    height: { type: Number, default: 70 },
  },
  computed: {
    sum() {
      return this.segments.reduce((acc, s) => acc + (s.value || 0), 0);
    },
    effectiveMax() {
      return this.max > 0 ? this.max : this.sum;
    },
    datasets() {
      const datasets = this.segments.map((s) => ({
        label: s.label,
        data: [s.value || 0],
        backgroundColor: s.color,
        barThickness: this.barThickness,
      }));
      // background track emulating Apex backgroundBarColors
      datasets.push({
        label: "",
        data: [Math.max(0, this.effectiveMax - this.sum)],
        backgroundColor: this.trackColor,
        barThickness: this.barThickness,
      });
      return datasets;
    },
  },
  watch: {
    datasets() {
      if (!this.chart) return;
      this.chart.data.datasets = this.datasets;
      this.chart.options.scales.x.max = this.effectiveMax;
      this.chart.update("none");
    },
  },
  mounted() {
    this.chart = new Chart(this.$refs.canvas, {
      type: "bar",
      data: {
        labels: [""],
        datasets: this.datasets,
      },
      options: {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        scales: {
          x: { stacked: true, display: false, min: 0, max: this.effectiveMax },
          y: { stacked: true, display: false },
        },
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
        },
      },
    });
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  },
};
</script>
<template>
  <div
    class="stacked-bar-chart w-100"
    dir="ltr"
    :style="{ height: `${height}px` }"
  >
    <div
      v-if="title"
      class="stacked-bar-chart-title"
      :style="{ color: titleColor }"
    >
      {{ title }}
    </div>
    <canvas ref="canvas"></canvas>
  </div>
</template>
<style scoped>
.stacked-bar-chart {
  position: relative;
}
.stacked-bar-chart-title {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
  pointer-events: none;
}
</style>
